import PropTypes from "prop-types"
import { Modal } from "antd"
import { useBreakpoints } from "modules/window/hooks/useBreakpoints"
import ReservationDetailPage from "./index"
import styles from "./ReservationDetailModal.module.css"

// Renders the Reservation detail screen inside a modal (e.g. opened from a calendar tile),
// instead of navigating to the routed page. The screen itself supplies its own header + close.
const ReservationDetailModal = ({ open, bookingUuid, onClose, onAssignmentsChange }) => {
  const breakpoint = useBreakpoints()
  const isMobile = ["xs", "xsm", "sm"].includes(breakpoint)

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      closable={false}
      destroyOnClose
      centered={!isMobile}
      width={isMobile ? "100%" : 960}
      className={`${styles.reservationModal} ${isMobile ? styles.reservationModalMobile : ""}`}
    >
      {bookingUuid && (
        <ReservationDetailPage
          uuid={bookingUuid}
          isModal
          onClose={onClose}
          onAssignmentsChange={onAssignmentsChange}
        />
      )}
    </Modal>
  )
}

ReservationDetailModal.propTypes = {
  open: PropTypes.bool,
  bookingUuid: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  // Fired after a crew/equipment assign or unassign succeeds inside the modal.
  onAssignmentsChange: PropTypes.func
}

export default ReservationDetailModal
